import { Injectable } from '@angular/core';

import { Cacheable } from '../models/cacheable.model';
import { OperationStream } from '../models/operation-stream.model';

export interface UserLicenses extends Cacheable {
    currentSkuInfo: ConsumerSkuInfo;
    expiredSkuInfo: ConsumerSkuInfo;
    diagnosticInfo: string;
}

export interface ConsumerSkuInfo {
    skuType: ConsumerSkuType;
    daysExpired: number;
}

// Do not change the order of items inside. The index value is used to sort user skus for reporting.
export enum ConsumerSkuType {
    O365Home,
    O365Personal,
    O365Solo,
    OtherSubscription,
    Perpetual,
    Perpetual2019,
    O365HomeTrial,
    NonActive,
    NotSubscribed,
    NotDetected
}

@Injectable()
export abstract class ConsumerLicenseService {

    public abstract getLicenses(): OperationStream<UserLicenses>;

}
